const SECRET = {
  SECRET_KEY: "123456654321"
};

export default SECRET;
